import Perfil from '../../spa/perfil/Perfil';

export default {
  path: 'perfil',
  name: 'perfil',
  component: Perfil,
};



// WEBPACK FOOTER //
// ./src/config/router/perfil.js